import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import { Transition } from './base.esm.js';

var styles = {
  init: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  }
};
var Fade = function Fade(_ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 250 : _ref$timeout,
      rest = _objectWithoutPropertiesLoose(_ref, ["timeout"]);

  return /* @__PURE__ */createElement(Transition, _extends({
    transition: "all " + timeout + "ms cubic-bezier(0.175, 0.885, 0.320, 1.175)",
    styles: styles,
    timeout: {
      enter: 50,
      exit: timeout
    }
  }, rest));
};

export { Fade };
//# sourceMappingURL=fade.esm.js.map
